import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { withRouter, RouteComponentProps, Link } from 'react-router-dom';
import isUndefined from 'lodash/isUndefined';
import {
  getReviewBook,
  setExpiredSession,
  setLoadingBook,
  IReviewBookState,
  setReviewBook,
  resetState,
} from 'src/store/slices/index';
import { IBookingSummary, ISessionKey } from 'src/common-types/index';
import { UrlUtils, getTimeout, getSessionObj } from 'src/utils/index';
import {
  Routes,
  SESSION_KEY_LABEL_ROOMS,
  SESSION_KEY_LABEL,
  HOTEL_ID_ELEMENT,
  PACKAGE_ID_ELEMENT,
  HOTEL_SESSION_KEY,
} from 'src/constants/index';
import { RootState } from 'src/store';
import { SkeletonReviewBook } from 'src/components/components/index';
import { ReviewBook } from '../review-book/review-book';
import { RoomInfo } from '../room-info';
import { Notification } from '../notification';
import './style.scss';

interface IMapStateToProps {
  reviewBookStore: IReviewBookState;
}

interface IMapDispatchToProps {
  getReviewBook: (numberId: number, packageId: string, sessionKey: ISessionKey | undefined) => void;
  setExpiredSession: (expiredSession: boolean) => void;
  setLoadingBook: (loadingBook: boolean) => void;
  setReviewBook: (data: IBookingSummary) => void;
  resetState: () => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps {}

interface IState {
  expirationTimeout: number;
}

const ZERO = 0;

class ReviewBookWrapperComponent extends React.Component<IProps, IState> {
  state: IState = {
    expirationTimeout: null,
  };

  hotelId = Number(this.props.history.location.pathname.split('/')[HOTEL_ID_ELEMENT]);
  packageId = this.props.history.location.pathname.split('/')[PACKAGE_ID_ELEMENT];

  onExpiredSession = (sessionData: ISessionKey) => {
    const expireDate = sessionData.expireDate;

    if (getTimeout(expireDate) < ZERO) {
      this.props.setExpiredSession(true);
    } else {
      this.setState({
        // @ts-ignore
        expirationTimeout: setTimeout(() => {
          this.props.setExpiredSession(true);
        }, getTimeout(expireDate)),
      });
    }
  };

  componentDidMount() {
    const values = UrlUtils.getValues();
    const sessionKey = getSessionObj(
      values[SESSION_KEY_LABEL_ROOMS] as ISessionKey,
      values[SESSION_KEY_LABEL] as ISessionKey,
    );

    if (!isUndefined(sessionKey)) {
      localStorage.setItem(HOTEL_SESSION_KEY, JSON.stringify(sessionKey));
    }

    const currentSessionKey = !isUndefined(sessionKey)
      ? sessionKey
      : JSON.parse(localStorage.getItem(HOTEL_SESSION_KEY));

    this.props.setLoadingBook(true);
    this.props.setReviewBook(null);
    this.props.getReviewBook(this.hotelId, this.packageId, currentSessionKey);
    this.onExpiredSession(currentSessionKey);
    window.scrollTo(ZERO, ZERO);
  }

  componentWillUnmount() {
    clearTimeout(this.state.expirationTimeout);
    this.props.resetState();
  }

  render(): React.ReactNode {
    const {
      loading,
      bookingSummary,
      expiredSession,
      loadingBooking,
      bookingComplete,
      isExternalError,
      isPriceChangedError,
      isSoldOutError,
      isBookingInProgress,
      isSavingsMismatch,
    } = this.props.reviewBookStore;
    const isNotification =
      bookingComplete ||
      loadingBooking ||
      isPriceChangedError ||
      isSoldOutError ||
      isBookingInProgress ||
      loading;

    return expiredSession || isExternalError ? (
      <Notification
        expiredSession={expiredSession}
        isSavingsMismatch={isSavingsMismatch}
        isExternalError={isExternalError}
      />
    ) : (
      <div className="review-book-wrapper">
        {!isNotification && (
          <div className="review-book-wrapper__header">
            <div className="review-book-wrapper__back-link">
              <Link to={`${Routes.Hotel}/${this.hotelId}/${location.search}`}>
                <FormattedMessage id="back.to.all.rooms" />
              </Link>
            </div>
            <h4 className="review-book-wrapper__title">
              <FormattedMessage id="review.book" />
            </h4>
            <p className="review-book-wrapper__description">
              <FormattedMessage id="enter.your.details" />
            </p>
          </div>
        )}
        {loading ? <SkeletonReviewBook /> : null}
        {bookingSummary && !loading ? (
          <div
            className={`review-book-wrapper__content ${
              isNotification ? 'wrapper-notification' : ''
            }`}
          >
            <ReviewBook />
            <RoomInfo />
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    reviewBookStore: state.reviewBookStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getReviewBook,
  setExpiredSession,
  setLoadingBook,
  setReviewBook,
  resetState,
};

export const ReviewBookWrapper = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ReviewBookWrapperComponent));
